import { env } from '@/env.mjs';

export const SEND_BUSINESS_FORM_API_URL = `${env.NEXT_PUBLIC_API_URL}/partners/sendMessage`;

export const SEND_BUSINESS_FORM_N8N_API_URL = `https://paypo.app.n8n.cloud/webhook/e773dfea-5808-4fce-89e6-c76b9287428f`;
